import { TRANSICAO_SCHEDULE } from "../utils/calculoReforma";

/**
 * Conteúdo da aba Parâmetros. O cronograma vem de TRANSICAO_SCHEDULE, o mesmo do cálculo,
 * para a tabela nunca divergir do que as outras abas usam. O último ano usa as premissas.
 */

const number = (v, digits) => (Number(v) || 0).toLocaleString("pt-BR", { minimumFractionDigits: digits, maximumFractionDigits: 2 });
export const rate = (v) => `${number(v, 0)}%`;
export const fixedRate = (v) => `${number(v, 2)}%`;

export const PREMISES = [
  { id: "cbsPlena2033", group: "Alíquota da reforma", label: "CBS plena em 2033", caption: "Federal, estimada" },
  { id: "ibsSpPlena2033", group: "Alíquota da reforma", label: "IBS SP pleno em 2033", caption: "Estimativa de estado e município de SP" },
  { id: "pctReceitaVeiculos", group: "Composição da receita", label: "Receita em produtos com ST", caption: "ST ou monofásicos. O restante é considerado demais produtos e serviços" },
  { id: "pctCogsVeiculos", group: "Custo", label: "COGS de produtos com ST", caption: "Custo da mercadoria vendida sobre a receita de produtos com ST ou monofásicos" },
  { id: "pctCogsPecasServ", group: "Custo", label: "COGS de demais produtos e serviços", caption: "Custo da mercadoria vendida sobre a receita de demais produtos e serviços" },
  { id: "issAtualServicos", group: "Regime atual", label: "ISS atual", caption: "Alíquota municipal sobre os 10% de receita de serviços" },
];

export const futureRates = (params, isIndustrial) => [
  { name: "CBS", value: rate(params.cbsPlena2033), base: "Receita menos créditos", applies: "yes", source: "PLP 68/2024" },
  { name: "IBS SP", note: "estimado", value: rate(params.ibsSpPlena2033), base: "Receita menos créditos", applies: "yes", source: "LC 214/2025" },
  { name: "Imposto Seletivo", value: "Variável", base: "1ª comercialização", applies: isIndustrial ? "maybe" : "no", source: "PLP 68/2024" },
];

export const currentRates = (params) => [
  { name: "PIS", value: "1,65%", regime: "Não cumulativo", note: "Crédito em entradas elegíveis" },
  { name: "COFINS", value: "7,60%", regime: "Não cumulativo", note: "Crédito em entradas elegíveis" },
  { name: "ICMS com ST, SP", value: "12%", regime: "Substituição tributária", note: "A empresa não recolhe: o substituto já reteve na cadeia" },
  { name: "ICMS normal", value: "18%", regime: "Normal, com crédito", note: "A empresa recolhe, com crédito das entradas" },
  { name: "ISS serviços", value: rate(params.issAtualServicos), regime: "Municipal", note: "Sobre 10% do faturamento, a receita de serviços" },
  { name: "IPI", value: "Variável", regime: "Fabricante ou importador", note: "Só fabricante ou importador recolhe, como será com o IS" },
];

export function transitionRows(params) {
  const last = TRANSICAO_SCHEDULE.length - 1;
  return TRANSICAO_SCHEDULE.map((row, i) => {
    const cbs = i === last ? Number(params.cbsPlena2033) || 0 : row.cbs * 100;
    const ibs = i === last ? Number(params.ibsSpPlena2033) || 0 : row.ibs * 100;
    return {
      year: row.ano,
      phase: row.fase,
      live: i === last,
      cbs,
      ibs,
      total: cbs + ibs,
      pisCofins: row.pisCofPct * 100,
      icmsIss: row.icmsIssPct * 100,
    };
  });
}
